// SITE_URL est lu à l'exécution côté serveur (les variables NEXT_PUBLIC_ sont figées au build).
export const SITE_URL = (process.env.SITE_URL || 'http://localhost:3000').replace(/\/$/, '')
export const FOUNDED = 2001
export const yearsSince = () => new Date().getFullYear() - FOUNDED

export const SITE = {
  name: 'EXELEC',
  fullName: 'EXELEC — Excellence Électronique',
  baseline: 'Excellence Électronique',
  signature: 'Innovation • Sécurité • Solutions',
  description:
    'EXELEC, entreprise de services numériques fondée en 2001 à Dakar : développement web et mobile, logiciels métier, portails, hébergement, audit informatique et digitalisation des processus.',
  city: 'Dakar, Sénégal',
}

export const NAV = {
  entreprise: [
    { href: '/entreprise', label: 'À propos d’EXELEC', desc: 'Histoire, mission et valeurs depuis 2001' },
    { href: '/entreprise/approche', label: 'Notre approche', desc: 'Une méthode claire, du besoin au déploiement' },
    { href: '/entreprise/secteurs', label: 'Secteurs accompagnés', desc: 'Entreprises, institutions et organisations' },
  ],
}

export const absoluteUrl = (path = '/') => `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
